.page {
  max-width: 1100px;
}

.section {
  margin-top: 40px;
}

.heading {
  margin-bottom: 12px;
  font-size: 1.125rem;
  font-weight: 650;
}

.note {
  color: var(--text-secondary);
}

.form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

@media (max-width: 560px) {
  .row {
    grid-template-columns: minmax(0, 1fr);
  }
}

.labelText {
  display: block;
  margin-bottom: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.fieldset {
  border: 0;
  padding: 0;
  margin: 0;
}

.time {
  min-height: 40px;
  padding: 0 10px;
  font: inherit;
  font-family: var(--font-mono);
  background: var(--bg-elevated);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
}

.iconBtn {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-primary);
  cursor: pointer;
}

.iconBtn:hover {
  color: var(--accent-text);
  border-color: var(--accent);
}

.card {
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
}

.cardHead {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px 16px;
  padding: 14px 16px;
  text-align: left;
  font: inherit;
  color: var(--text-primary);
  background: transparent;
  border: 0;
  cursor: pointer;
}

.cardBody {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;
  border-top: 1px solid var(--border-subtle);
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.deviceList {
  border-top: 1px solid var(--border-primary);
}

.device {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid var(--border-subtle);
}

.deviceInfo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.deviceName {
  font-weight: 600;
}

.muted {
  color: var(--text-muted);
  font-size: 0.875rem;
}

.mono {
  font-family: var(--font-mono);
  font-size: 0.8125rem;
}

/* Zugangsdaten: Schlüssel/Wert-Liste mit Kopieren-Schaltfläche. */
.credentials {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  border: 1px solid var(--border-primary);
}

.credentials dt,
.credentials dd {
  margin: 0;
  padding: 10px 14px;
  border-bottom: 1px solid var(--border-subtle);
}

.credentials dt {
  color: var(--text-muted);
  font-size: 0.875rem;
}

.credentials dd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-family: var(--font-mono);
  font-size: 0.9375rem;
  overflow-wrap: anywhere;
}

.credentials dt:last-of-type,
.credentials dd:last-of-type {
  border-bottom: 0;
}

.copy {
  flex: none;
  background: transparent;
  border: 1px solid var(--border-primary);
  color: var(--text-secondary);
  min-height: 28px;
  padding: 0 10px;
  font-size: 0.8125rem;
  font-family: var(--font-sans);
  cursor: pointer;
}

.copy:hover {
  color: var(--text-primary);
  border-color: var(--text-secondary);
}

.steps {
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--text-secondary);
  font-size: 0.9375rem;
  list-style: decimal;
}

.code {
  margin: 8px 0 0;
  padding: 12px 14px;
  overflow-x: auto;
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-subtle);
}

.pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 24px;
  margin-top: 20px;
}
